import {Component, OnInit} from '@angular/core';

import {MatDialog} from "@angular/material/dialog";
import {AboutUsComponent} from "../legal/about-us/about-us.component";
import {TermsOfUseComponent} from "../legal/terms-of-use/terms-of-use.component";
import {ContactUsComponent} from "../legal/contact-us/contact-us.component";


@Component({
  selector: 'app-disclaimer-links',
  templateUrl: './disclaimer-links.component.html',
  styleUrls: ['./disclaimer-links.component.scss']
})
export class DisclaimerLinksComponent implements OnInit {

  constructor(public dialog: MatDialog) {
  }

  ngOnInit(): void {
    // todo
  }

  openAboutUs(): void {
    this.dialog.open(AboutUsComponent);
  }

  disclaimer(): void {
    // TODO
  }

  openTermsOfUse(): void {
    this.dialog.open(TermsOfUseComponent);
  }

  openContactUs(): void {
    this.dialog.open(ContactUsComponent);
  }
}
